/* eslint-disable quotes */
const ActivityIcon = require("./svg/activity.svg").default;
const AddIcon = require("./svg/add.svg").default;
const AddCircleIcon = require("./svg/add_circle.svg").default;
const EditIcon = require("./svg/edit.svg").default;
const CardViewIcon = require("./svg/card_view.svg").default;
const ListViewIcon = require("./svg/list_view.svg").default;
const PreviewIcon = require("./svg/preview.svg").default;
const SettingsIcon = require("./svg/gear.svg").default;
const PageIcon = require("./svg/page.svg").default;
const TrafficIcon = require("./svg/traffic.svg").default;
const TemplateIcon = require("./svg/site_template.svg").default;
const TrashIcon = require("./svg/trash.svg").default;
const UserIcon = require("./svg/user.svg").default;
const UsersIcon = require("./svg/users.svg").default;
const ArrowDownIcon = require("./svg/arrow_down.svg").default;
const ArrowRightIcon = require("./svg/arrow_right.svg").default;
const ArrowUpIcon = require("./svg/arrow_up.svg").default;
const ArrowLeftIcon = require("./svg/arrow_left.svg").default;
const DoubleArrowRightIcon = require("./svg/double_arrow_right.svg").default;
const DoubleArrowLeftIcon = require("./svg/double_arrow_left.svg").default;
const ArrowEndLeftIcon = require("./svg/arrow-end_left.svg").default;
const ArrowEndRightIcon = require("./svg/arrow-end_right.svg").default;
const CheckboxCheckedIcon = require("./svg/small_checkbox_checked.svg").default;
const CheckboxPartialCheckedIcon = require("./svg/small_checkbox_partial_checked.svg").default;
const CheckboxUncheckedIcon = require("./svg/small_checkbox_unchecked.svg").default;
const CalendarIcon = require("./svg/calendar.svg").default;
const CalendarEndIcon = require("./svg/calendar_end.svg").default;
const CalendarStartIcon = require("./svg/calendar_start.svg").default;
const CheckboxIcon = require("./svg/checkbox.svg").default;
const CheckMarkIcon = require("./svg/checkmark.svg").default;
const ClockStopIcon = require("./svg/clock_stop.svg").default;
const CrossOutIcon = require("./svg/cross_out.svg").default;
const CycleIcon = require("./svg/cycle.svg").default;
const DragRowIcon = require("./svg/drag_row.svg").default;
const ErrorStateIcon = require("./svg/error_state.svg").default;
const EyeIcon = require("./svg/eye.svg").default;
const FolderIcon = require("./svg/folder.svg").default;
const GlobalIcon = require("./svg/global.svg").default;
const HistoryIcon = require("./svg/history.svg").default;
const LanguagesIcon = require("./svg/languages.svg").default;
const LanguagesPageIcon = require("./svg/languages_page.svg").default;
const LinkIcon = require("./svg/link.svg").default;
const LockClosedIcon = require("./svg/lock_closed.svg").default;
const MoreMenuIcon = require("./svg/more.svg").default;
const SiteGroupNoData = require("./svg/site_group_nodata.svg").default;
const PagesIcon = require("./svg/pages.svg").default;
const SearchFileSystemIcon = require("./svg/search_filesystem.svg").default;
const SearchIcon = require("./svg/search.svg").default;
const ShieldIcon = require("./svg/shield.svg").default;
const Signature = require("./svg/signature-solid.svg").default;
const SiteGroupIcon = require("./svg/site_group.svg").default;
const Steps1Icon = require("./svg/steps1.svg").default;
const Steps2Icon = require("./svg/steps2.svg").default;
const Steps3Icon = require("./svg/steps3.svg").default;
const ToolTipIcon = require("./svg/tool_tip.svg").default;
const UploadIcon = require("./svg/upload.svg").default;
const UploadCircleIcon = require("./svg/upload_circle.svg").default;
const UserSlash = require("./svg/user-slash-solid.svg").default;
const XIcon = require("./svg/x.svg").default;
const XThinIcon = require("./svg/x_thin.svg").default;
const ModuleIcon = require("./svg/module.svg").default;
const ArrowMoveUpIcon = require("./svg/arrow_moveup.svg").default;
const ArrowMoveDownIcon = require("./svg/arrow_movedown.svg").default;
const TableEmptyState = require("./svg/table_empty.svg").default;
const ArrowBack = require("./svg/arrow_back.svg").default;
const ArrowForward = require("./svg/arrow_forward.svg").default;
const DownloadIcon = require("./svg/download.svg").default;
const ImageIcon = require("./svg/image.svg").default;
const HourglassIcon = require("./svg/hourglass.svg").default;
const CollapseTree = require("./svg/collapse_tree.svg").default;
const ExpandTree = require("./svg/expand_tree.svg").default;
const TreeLinkIcon = require("./svg/tree_link.svg").default;
const TreeDraftIcon = require("./svg/draft.svg").default;
const TreeMoreIcon = require("./svg/tree_more.svg").default;
const TreePaperClip = require("./svg/paperclip.svg").default;
const TreeAddPage = require("./svg/tree_add_page.svg").default;
const TreeEye = require("./svg/tree_eye.svg").default;
const TreeEdit = require("./svg/tree_edit.svg").default;
const TreeCopy = require("./svg/tree_copy.svg").default;
const TreeAnalytics = require("./svg/tree_analytics.svg").default;
const PagesSearchIcon = require("./svg/pages_search.svg").default;
const PagesVerticalMore = require("./svg/pages_more_vertical.svg").default;
export {
    ActivityIcon,
    AddIcon,
    AddCircleIcon,
    EditIcon,
    CardViewIcon,
    ListViewIcon,
    PreviewIcon,
    SettingsIcon,
    PageIcon,
    TrafficIcon,
    TemplateIcon,
    TrashIcon,
    UserIcon,
    UsersIcon,
    ArrowDownIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ArrowLeftIcon,
    DoubleArrowRightIcon,
    DoubleArrowLeftIcon,
    ArrowEndLeftIcon,
    ArrowEndRightIcon,
    CheckboxCheckedIcon,
    CheckboxPartialCheckedIcon,
    CheckboxUncheckedIcon,
    CalendarIcon,
    CalendarEndIcon,
    CalendarStartIcon,
    CheckboxIcon,
    CheckMarkIcon,
    ClockStopIcon,
    CrossOutIcon,
    CycleIcon,
    DragRowIcon,
    ErrorStateIcon,
    EyeIcon,
    FolderIcon,
    GlobalIcon,
    HistoryIcon,
    LanguagesIcon,
    LanguagesPageIcon,
    LinkIcon,
    LockClosedIcon,
    MoreMenuIcon,
    SiteGroupNoData,
    PagesIcon,
    SearchFileSystemIcon,
    SearchIcon,
    ShieldIcon,
    SiteGroupIcon,
    Steps1Icon,
    Steps2Icon,
    Steps3Icon,
    ToolTipIcon,
    UploadIcon,
    UploadCircleIcon,
    XIcon,
    XThinIcon,
    ModuleIcon,
    ArrowMoveUpIcon,
    ArrowMoveDownIcon,
    TableEmptyState,
    ArrowBack,
    ArrowForward,
    DownloadIcon,
    ImageIcon,
    HourglassIcon,
    CollapseTree,
    ExpandTree,
    TreeLinkIcon,
    TreeDraftIcon,
    TreeMoreIcon,
    TreePaperClip,
    TreeAddPage,
    TreeEye,
    TreeEdit,
    TreeCopy,
    TreeAnalytics,
    PagesSearchIcon,
    PagesVerticalMore,
    Signature,
    UserSlash
};
